<!-- Top Contact Bar - Compact & Minimal -->
<section class="top-contact-bar">
  <div class="container">
    <div class="contact-container">
      <div class="contact-items">
        <div class="contact-item">
          <a href="mailto:enquiry@manpowergroup.com" class="contact-link">
            <i class="fas fa-envelope contact-icon"></i>
            <span class="contact-text">Enquire Now: <span class="contact-value">enquiry@manpowergroup.com</span></span>
          </a>
        </div>
        <div class="contact-item">
          <a href="tel:1800 419 4001" class="contact-link">
            <i class="fas fa-users contact-icon"></i>
            <span class="contact-text">For Associates: <span class="contact-value">1800 419 4001</span></span>
          </a>
        </div>
        <div class="contact-item">
          <a href="tel:1800 120 120 000" class="contact-link">
            <i class="fas fa-briefcase contact-icon"></i>
            <span class="contact-text">For Business Inquiries: <span class="contact-value">1800 120 120 000</span></span>
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Professional Navbar - Built from Scratch -->
<header class="main-navigation-bar">
  <div class="container" style="height: 100%;">
    <div class="nav-container">
      
      <!-- Left Side - Logo -->
      <div class="logo-container">
        <a href="https://manpowergroup.co.in/" target="_blank" class="logo-wrapper">
          <img src="assets/image/MPG_Logo.png" alt="ManpowerGroup" class="company-logo">
        </a>
      </div>

      <!-- Right Side - Navigation & Actions -->
      <div class="nav-actions-wrapper">
        
        <!-- Navigation Links -->
        <!-- <nav class="primary-navigation">
          <ul class="nav-list">
            <li class="nav-list-item">
              <a routerLink="/jobs" 
                 routerLinkActive="nav-active"
                 class="navigation-link">
                <i class="fas fa-briefcase nav-link-icon"></i>
                <span>Job Opportunities</span>
              </a>
            </li>
            <li class="nav-list-item">
              <a href="https://www.manpowergroup.co.in/aboutus.html" target="_blank"
                 class="navigation-link">
                <i class="fas fa-info-circle nav-link-icon"></i>
                <span>About Us</span>
              </a>
            </li>
          </ul>
        </nav> -->

        <!-- Authentication Area -->
        <div class="auth-area">
          
          <!-- Guest User Actions -->
          <div *ngIf="!(session && session.token)" class="guest-buttons">
            <a routerLink="/login" class="action-button secondary-button">
              <i class="fas fa-sign-in-alt"></i>
              <span>Sign In</span>
            </a>
            <a routerLink="/registration" class="action-button primary-button">
              <i class="fas fa-user-plus"></i>
              <span>Sign Up</span>
            </a>
          </div>

          <!-- Logged In User - Desktop Only -->
          <div *ngIf="session && session.token" class="user-profile-area desktop-only">
            <div class="profile-trigger" (click)="toggleUserMenu()">
              <div class="user-avatar-circle">
                <span class="user-initials">{{ getUserInitial() }}</span>
              </div>
              <div class="user-name-display">
                <span class="user-name">{{ session.firstName || 'User' }}</span>
                <i class="fas fa-chevron-down menu-arrow" [class.arrow-up]="userMenuOpen"></i>
              </div>
            </div>

            <!-- User Dropdown Menu -->
            <div class="profile-dropdown-menu" [ngClass]="{'menu-visible': userMenuOpen}">
              <div class="dropdown-inner">
                
                <!-- User Info Header -->
                <div class="user-info-header">
                  <div class="header-avatar">
                    <span class="header-initials">{{ getUserInitial() }}</span>
                  </div>
                  <div class="header-details">
                    <div class="header-name">{{ session.firstName || 'User' }}</div>
                    <div class="header-email">{{ session.emailId || 'user@example.com' }}</div>
                  </div>
                </div>

                <!-- Menu Options -->
                <div class="menu-options">
                  <a routerLink="/edit-profile" class="menu-option" (click)="closeUserMenu()">
                    <i class="fas fa-user-edit option-icon"></i>
                    <div class="option-text">
                      <span class="option-title">Edit Profile</span>
                      <span class="option-desc">Update your information</span>
                    </div>
                  </a>

                  <a routerLink="/my-journey" class="menu-option" (click)="closeUserMenu()">
                    <i class="fas fa-route option-icon"></i>
                    <div class="option-text">
                      <span class="option-title">My Journey</span>
                      <span class="option-desc">Track your progress</span>
                    </div>
                  </a>

                  <a routerLink="/my-jobs" class="menu-option" (click)="closeUserMenu()">
                    <i class="fas fa-briefcase option-icon"></i>
                    <div class="option-text">
                      <span class="option-title">My Applications</span>
                      <span class="option-desc">View applied jobs</span>
                    </div>
                  </a>

                  <div class="menu-separator"></div>

                  <a (click)="changePassword(); closeUserMenu()" class="menu-option">
                    <i class="fas fa-shield-alt option-icon"></i>
                    <div class="option-text">
                      <span class="option-title">Security Settings</span>
                      <span class="option-desc">Password & security</span>
                    </div>
                  </a>

                  <a (click)="logout(); closeUserMenu()" class="menu-option danger-option">
                    <i class="fas fa-sign-out-alt option-icon"></i>
                    <div class="option-text">
                      <span class="option-title">Sign Out</span>
                      <span class="option-desc">Logout from account</span>
                    </div>
                  </a>
                </div>

              </div>
            </div>
          </div>

        </div>

        <!-- Mobile Menu Toggle -->
        <button class="mobile-toggle-button" (click)="toggleMobileMenu()" [class.toggle-active]="mobileMenuOpen">
          <span class="toggle-bar"></span>
          <span class="toggle-bar"></span>
          <span class="toggle-bar"></span>
        </button>

      </div>

    </div>
  </div>

  <!-- Mobile Menu Backdrop -->
  <div class="mobile-backdrop" *ngIf="mobileMenuOpen" (click)="closeMobileMenu()"></div>

  <!-- Mobile Navigation Panel -->
  <div class="mobile-nav-panel" [class.panel-open]="mobileMenuOpen">
    <div class="mobile-panel-content">
      
      <!-- Mobile Header -->
      <div class="mobile-panel-header">
        <img src="assets/image/MPG_Logo.png" alt="ManpowerGroup" class="mobile-header-logo">
        <button class="mobile-close-button" (click)="closeMobileMenu()">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <!-- Mobile User Profile -->
      <div *ngIf="session && session.token" class="mobile-user-profile">
        <div class="mobile-profile-avatar">
          <span class="mobile-avatar-initial">{{ getUserInitial() }}</span>
        </div>
        <div class="mobile-profile-info">
          <div class="mobile-profile-name">{{ session.firstName || 'User' }}</div>
          <div class="mobile-profile-email">{{ session.emailId || 'user@example.com' }}</div>
        </div>
      </div>

      <!-- Mobile Navigation Menu -->
      <div class="mobile-menu-list">
        <!-- <a routerLink="/jobs" class="mobile-menu-link" (click)="closeMobileMenu()">
          <i class="fas fa-briefcase mobile-link-icon"></i>
          <span>Job Opportunities</span>
        </a>
        
        <a href="https://www.manpowergroup.co.in/aboutus.html" target="_blank" class="mobile-menu-link" (click)="closeMobileMenu()">
          <i class="fas fa-info-circle mobile-link-icon"></i>
          <span>About Us</span>
        </a> -->

        <!-- Mobile Auth Buttons -->
        <div *ngIf="!(session && session.token)" class="mobile-auth-section">
          <a routerLink="/login" class="mobile-auth-link signin" (click)="closeMobileMenu()">
            <i class="fas fa-sign-in-alt mobile-link-icon"></i>
            <span>Sign In</span>
          </a>
          <a routerLink="/registration" class="mobile-auth-link signup" (click)="closeMobileMenu()">
            <i class="fas fa-user-plus mobile-link-icon"></i>
            <span>Sign Up</span>
          </a>
        </div>

        <!-- Mobile User Options -->
        <div *ngIf="session && session.token" class="mobile-user-options">
          <div class="mobile-section-label">Account Options</div>
          
          <a routerLink="/edit-profile" class="mobile-menu-link" (click)="closeMobileMenu()">
            <i class="fas fa-user-edit mobile-link-icon"></i>
            <span>Edit Profile</span>
          </a>
          
          <a routerLink="/my-journey" class="mobile-menu-link" (click)="closeMobileMenu()">
            <i class="fas fa-route mobile-link-icon"></i>
            <span>My Journey</span>
          </a>
          
          <a routerLink="/my-jobs" class="mobile-menu-link" (click)="closeMobileMenu()">
            <i class="fas fa-briefcase mobile-link-icon"></i>
            <span>My Applications</span>
          </a>
          
          <a (click)="changePassword(); closeMobileMenu()" class="mobile-menu-link">
            <i class="fas fa-shield-alt mobile-link-icon"></i>
            <span>Security Settings</span>
          </a>
          
          <div class="mobile-menu-divider"></div>
          
          <a (click)="logout(); closeMobileMenu()" class="mobile-menu-link danger-link">
            <i class="fas fa-sign-out-alt mobile-link-icon"></i>
            <span>Sign Out</span>
          </a>
        </div>
      </div>

    </div>
  </div>

</header>